import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AlarmActionsService = {
    apply: async (payload) => axios.post(`${API_URL}/alarm_actions/apply`, payload).then(({data}) => data.data).catch((err) => { throw err }),
    getAlarmImage: async (url) => axios.get(`${API_URL}/alarm_actions/getAlarmImage/${url}`).then(({data}) => data.data).catch((err) => { throw err }),
};

export default AlarmActionsService;